
// ---------------------------------------------------
// Event
// ---------------------------------------------------

export const trackEvent = (eName, eValue) => {
  if (typeof window.dpAnalytics !== 'undefined') {
    window.dpAnalytics.trackEvent('TOTO100LETÍ', eName, eValue);
  }
};



// WEBPACK FOOTER //
// ./src/utils/Stats.js